import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      activities: 'Activities',
      contact: 'Contact',
    },
    hero: {
      title: 'Renewable Energy for a Sustainable Future',
      subtitle: 'PI ENERGI DOOEL Resen is a renewable energy company focused on the production of electricity from solar energy.',
      description: 'The company operates in North Macedonia and contributes to the development of environmentally friendly and sustainable energy solutions.',
      focus: 'Key focus areas:',
      focus1: 'Solar power generation',
      focus2: 'Renewable energy solutions',
      focus3: 'Environmentally responsible electricity production',
    },
    about: {
      title: 'About the Company',
      description1: 'PI ENERGI DOOEL Resen is a privately owned company established in 2020 in North Macedonia.',
      description2: 'The company specializes in the production of electricity from renewable energy sources, with a primary focus on solar energy.',
      description3: 'Our activities support the transition to clean energy and aim to reduce environmental impact through sustainable power generation.',
      keyInfo: 'Key information:',
      established: 'Established',
      establishedDate: '26 November 2020',
      legalForm: 'Legal form',
      legalFormValue: 'DOOEL (Limited Liability Company – single member)',
      status: 'Status',
      statusValue: 'Active',
      jurisdiction: 'Jurisdiction',
      jurisdictionValue: 'North Macedonia',
    },
    activities: {
      title: 'Activities',
      subtitle: 'Solar Energy Production',
      description: 'PI ENERGI DOOEL Resen is engaged in:',
      activity1: 'Production of electricity from solar power plants',
      activity2: 'Development and operation of renewable energy facilities',
      activity3: 'Supply of clean electricity to the domestic energy market',
      primaryActivity: 'Primary activity code:',
      activityCode: '35.120 – Production of electricity from renewable energy sources',
      compliance: 'All activities are conducted in compliance with applicable national regulations and energy sector standards.',
    },
    contact: {
      title: 'Contact',
      address: 'Registered address:',
      addressValue: 'Goce Delecev no. 3, Resen, North Macedonia',
      vat: 'VAT number:',
      phone: 'Phone:',
      email: 'Email:',
    },
  },
  mk: {
    nav: {
      home: 'Почетна',
      about: 'За нас',
      activities: 'Дејности',
      contact: 'Контакт',
    },
    hero: {
      title: 'Обновлива енергија за одржлива иднина',
      subtitle: 'PI ENERGI DOOEL Resen е компанија од областа на обновливите извори на енергија, специјализирана за производство на електрична енергија од сончева енергија.',
      description: 'Компанијата работи во Северна Македонија и придонесува кон развојот на еколошки и одржливи енергетски решенија.',
      focus: 'Главни насоки:',
      focus1: 'Производство на електрична енергија од сонце',
      focus2: 'Обновливи извори на енергија',
      focus3: 'Еколошки одговорно производство на електрична енергија',
    },
    about: {
      title: 'За компанијата',
      description1: 'PI ENERGI DOOEL Resen е приватна компанија основана во 2020 година во Северна Македонија.',
      description2: 'Основна дејност на компанијата е производство на електрична енергија од обновливи извори, со главен фокус на сончевата енергија.',
      description3: 'Активностите на компанијата се насочени кон поддршка на енергетската транзиција и намалување на влијанието врз животната средина.',
      keyInfo: 'Клучни информации:',
      established: 'Основана',
      establishedDate: '26 ноември 2020 година',
      legalForm: 'Правна форма',
      legalFormValue: 'DOOEL (друштво со ограничена одговорност – едно лице)',
      status: 'Статус',
      statusValue: 'Активна',
      jurisdiction: 'Јурисдикција',
      jurisdictionValue: 'Северна Македонија',
    },
    activities: {
      title: 'Дејности',
      subtitle: 'Производство на сончева електрична енергија',
      description: 'PI ENERGI DOOEL Resen врши:',
      activity1: 'Производство на електрична енергија од соларни електрани',
      activity2: 'Управување и експлоатација на објекти за обновлива енергија',
      activity3: 'Испорака на чиста електрична енергија на домашниот пазар',
      primaryActivity: 'Основна дејност:',
      activityCode: '35.120 – Производство на електрична енергија од обновливи извори',
      compliance: 'Дејностите се вршат во согласност со важечките законски прописи и стандарди во енергетскиот сектор.',
    },
    contact: {
      title: 'Контакт',
      address: 'Регистрирана адреса:',
      addressValue: 'ул. Гоце Делчев бр. 3, Ресен, Северна Македонија',
      vat: 'ДДВ број (VAT):',
      phone: 'Телефон:',
      email: 'Е-пошта:',
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'mk' : 'en');
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};